'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
require('classnames');
require('../../../Box/Box.js');
require('../../../../style-inject.es-dcee06b6.js');
var components_Icon_Icon = require('../../../Icon/Icon.js');
var Api = require('@sendsprint/api-types');
require('../../../Flag/assets/Ca.js');
require('../../../Flag/assets/Gb.js');
require('../../../Flag/assets/Gh.js');
require('../../../Flag/assets/Ke.js');
require('../../../Flag/assets/Ng.js');
require('../../../Flag/assets/Us.js');
require('../../../Flag/assets/Za.js');
require('../../../Flag/assets/None.js');
require('../../../Flag/utils/getFlagSvgByCountryInitials.js');
var components_Flag_Flag = require('../../../Flag/Flag.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Api__default = /*#__PURE__*/_interopDefaultLegacy(Api);

const handleIcon = ({ icon, size, className }) => {
    switch (icon) {
        case Api__default['default'].Model.CountryInitials.Canada:
        case Api__default['default'].Model.CountryInitials.Ghana:
        case Api__default['default'].Model.CountryInitials.Kenya:
        case Api__default['default'].Model.CountryInitials.Nigeria:
        case Api__default['default'].Model.CountryInitials.NigeriaNig:
        case Api__default['default'].Model.CountryInitials.SouthAfrica:
        case Api__default['default'].Model.CountryInitials.UnitedKingdom:
        case Api__default['default'].Model.CountryInitials.UnitedStates:
            return React__default['default'].createElement(components_Flag_Flag, { countryInitials: icon, className: className, size: size });
        default:
            return React__default['default'].createElement(components_Icon_Icon, { size: size, svg: icon, className: className });
    }
};

exports.handleIcon = handleIcon;
